import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  width: 100%;
  position: relative;
  padding: ${spacing(8)} ${spacing(10)} ${spacing(10)};

  .logo-container {
    display: flex;
    align-items: center;
    height: 120px;
  }

  .MarcomPricingPage-hero {
    width: 100%;
  }

  .MarcomPricingPage-binCard {
    width: 100%;
  }

  .MarcomPricingPage-featuresComparisonTable {
    margin-top: 48px;
  }
`
